// Generated by ReScript, PLEASE EDIT WITH CARE


var rootContainer = "my-4 md:my-4 lg:px-2 w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/5";

var gridContainer = "my-4 md:my-4 px-2 w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/5";

var innerContainer = "relative overflow-hidden rounded-lg shadow-lg bg-white";

var cardImg = "block h-full w-full";

var cardName = "font-semibold text-sm leading-4 sm:text-17px sm:leading-5 px-3 md:px-4 my-2";

var cardPrice = "text-mid-gray px-3 md:px-4 text-xs sm:text-sm leading-4 pb-3";

export {
  rootContainer ,
  gridContainer ,
  innerContainer ,
  cardImg ,
  cardName ,
  cardPrice ,
}
/* No side effect */
